import React, { lazy } from 'react';
import { useRouteMatch } from 'react-router';
import { useShortlists } from 'apis/CompanyAPI/users/useShortlists';
import Resource from 'util/resource/Resource';
import CollectionPage from './CollectionPage';

const Shortlist = lazy(() => import('pages/Shortlists/Shortlist'));

/** With the `collections-hub` preview on, the user's own lists get the new page; other lists keep the current one. */
export default function CollectionRoute() {
  const match = useRouteMatch<{ id: string }>();
  const { resource: shortlistResource } = useShortlists();

  return (
    <Resource resource={shortlistResource}>
      {shortlists => (shortlists.values.some(list => list.id === match.params.id) ? <CollectionPage /> : <Shortlist />)}
    </Resource>
  );
}
